import { useState } from "react";
import Modal from "../../components/common/Modal";
import CrudForm from "../../components/common/crud/CrudForm";
import companyService from "../../services/companyService";
import alertService from "../../utils/alertService";
import { normalizeApiError } from "../../utils/apiError";

const companyFormSchema = [
  {
    name: "companyName",
    label: "Company Name",
    type: "text",
    placeholder: "e.g. Ferrovant Global",
    validation: { required: true },
  },
  {
    name: "email",
    label: "Email Address",
    type: "text",
    placeholder: "info@company.com",
    validation: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      patternMessage: "Invalid email format",
    },
  },
  {
    name: "companyGSTNo",
    label: "GST Number",
    type: "text",
    placeholder: "27AAAAA0000A1Z5",
    validation: {
      required: true,
      pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      patternMessage: "Invalid GST format (e.g. 27AAAAA0000A1Z5)",
    },
  },
  {
    name: "stateName",
    label: "State Name",
    type: "text",
    placeholder: "e.g. Maharashtra",
    validation: { required: true },
  },
  {
    name: "stateCode",
    label: "State Code",
    type: "text",
    placeholder: "Code",
    validation: { required: true, maxLength: 2 },
  },
  {
    name: "companyAddress",
    label: "Company Address",
    type: "textarea",
    placeholder: "Full office address...",
    validation: { required: true },
  },
  {
    name: "websiteLink",
    label: "Website Link",
    type: "text",
    placeholder: "https://www.company.com",
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    defaultValue: true,
  },
];

function CompanyCreateModal({ isOpen, onClose, onSuccess }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await companyService.createCompany(values);
      alertService.success("Company created successfully.");
      onSuccess?.();
      onClose();
    } catch (err) {
      alertService.error(normalizeApiError(err).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add New Company" size="lg">
      <CrudForm
        mode="create"
        schema={companyFormSchema}
        initialValues={{ isActive: true }}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmit}
        onCancel={onClose}
      />
    </Modal>
  );
}

export default CompanyCreateModal;
